require('./uploadDocumentsOpenYoung.scss');

// @ vendors
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const React = require('react');

// @ helpers
const { FormattedText, hasTranslation } = require('core/i18n').i18n;
const { isDocumentUploadAllowed, isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @ commons
const { DragNDropUpload } = require('commonsComponents/dragNDropUpload');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKMessage } = require('commonsComponents/OKMessage');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @ utilities
const { getTextDescription, getTextLinkDescription } = require('utilities/dragNDropUpload');

// @ actions
const uploadDocumentsOpenYoungActions = require('actions/uploadDocumentsOpenYoung');

// @ constants
const {
    DRAG_N_DROP_UPLOAD_FILE_TEXT,
    DRAG_N_DROP_UPLOAD_MAX_LENGTH_FILE_NAME,
    DRAG_N_DROP_UPLOAD_TITLE,
} = require('constants/commonsComponents');
const {
    PROC_OPEN_YOUNG_ATTACH_DOCUMENTATION,
    recordLink,
    recordPath,
} = require('utilities/tagging');
const VALID_TYPES_FILE = ['jpg','jpeg','png'];
const VALID_TYPES_FILE_ERROR_MESSAGE = ['jpg','png'];

class UploadDocumentsOpenYoung extends React.Component {
    constructor(props) {
        super(props);

        this.buildDniDocumentation = this.buildDniDocumentation.bind(this);
        this.buildDragNDrop = this.buildDragNDrop.bind(this);
        this.buildFamilyBookDocumentation = this.buildFamilyBookDocumentation.bind(this);
        this.buildTipsPictures = this.buildTipsPictures.bind(this);
        this.handleOnChangeFileDni = this.handleOnChangeFileDni.bind(this);
        this.handleOnChangeFileFamilyBook = this.handleOnChangeFileFamilyBook.bind(this);
    }

    componentDidMount() {
        recordPath('adjuntar documentacion', '', PROC_OPEN_YOUNG_ATTACH_DOCUMENTATION, 'inicio', 'tarjeta prepago open young');
    }

    handleOnChangeFileDni(fileState) {
        const { addFileDniAndValidate } = this.props;

        if (!!fileState && !fileState.error) {
            addFileDniAndValidate(fileState);
        }
    }

    handleOnChangeFileFamilyBook(fileState) {
        const { addFileFamilyBookAndValidate } = this.props;

        if (!!fileState) {
            addFileFamilyBookAndValidate(fileState);
        }
    }

    buildDragNDrop(idName, onChange, handleRemoveFile, handleError) {
        const textDescription = getTextDescription(false);
        const textLinkDescription = getTextLinkDescription(false);
        const texts = {
            maxLengthError: <FormattedText value="uploadDocumentsOpenYoung-uploadDocumentsOpenYoung_maxLengthError" injectedStrings={[DRAG_N_DROP_UPLOAD_MAX_LENGTH_FILE_NAME]} />,
            sizeError: <FormattedText value="uploadDocumentsOpenYoung-uploadDocumentsOpenYoung_sizeError" injectedStrings={[3.5]} />,
            typeError: <FormattedText value="uploadDocumentsOpenYoung-uploadDocumentsOpenYoung_typeError" injectedStrings={[VALID_TYPES_FILE_ERROR_MESSAGE.join(', ')]} />,
            whiteListError: <FormattedText value="uploadDocumentsOpenYoung-uploadDocumentsOpenYoung_whiteListError" />,
        };

        const onError = fileState => {
            recordLink('openyoung-documentacion', 'error archivo');
            if (!!handleError) {
                handleError(fileState);
            }
        };

        return (
            <DragNDropUpload
                errorMessage=""
                fileText={DRAG_N_DROP_UPLOAD_FILE_TEXT}
                handleRemoveFile={handleRemoveFile}
                hideShowAttachLink={true}
                hideUploadedFileList={true}
                disabled={!isDocumentUploadAllowed()}
                iconClass="upload-documents-open-young__icon-upload"
                idName={idName}
                isModern={true}
                isTrashVisible={true}
                maxSize={3584}//Should be in binary format
                onChange={onChange}
                onError={onError}
                overwriteFile={true}
                successIconClass="upload-documents-open-young__icon-success"
                textDescription={textDescription}
                textLinkDescription={textLinkDescription}
                texts={texts}
                title={DRAG_N_DROP_UPLOAD_TITLE}
                validTypesFile={VALID_TYPES_FILE}
            />
        );
    }

    buildTipsPictures() {
        let content;
        if (!isPrintOfficeMode()) {
            content = (
                <section className="upload-documents-open-young__tips-container">
                    <FormattedText
                        className="upload-documents-open-young__tips-subtitle"
                        value="uploadDocumentsOpenYoung-uploadDocumentsOpenYoung_tipsPhotosTitle"
                    />
                    <div className="row upload-documents-open-young__tips">
                        <div className="col-xs-3 upload-documents-open-young__tip">
                            <i className="upload-documents-open-young__icon icon-superficie-plana" />
                            <FormattedText value="uploadDocumentsOpenYoung-uploadDocumentsOpenYoung_tipsPhotos1" />
                        </div>
                        <div className="col-xs-3 upload-documents-open-young__tip upload-documents-open-young__tip--middle">
                            <i className="upload-documents-open-young__icon icon-nitidez" />
                            <FormattedText value="uploadDocumentsOpenYoung-uploadDocumentsOpenYoung_tipsPhotos2" />
                        </div>
                        <div className="col-xs-3 upload-documents-open-young__tip">
                            <i className="upload-documents-open-young__icon icon-luz-natural" />
                            <FormattedText value="uploadDocumentsOpenYoung-uploadDocumentsOpenYoung_tipsPhotos3" />
                        </div>
                        <div className="col-xs-3 upload-documents-open-young__tip">
                            <i className="upload-documents-open-young__icon icon-subir" />
                            <FormattedText value="uploadDocumentsOpenYoung-uploadDocumentsOpenYoung_tipsPhotos4" />
                        </div>
                    </div>
                </section>
            );
        }

        return content;
    }

    buildDniDocumentation() {
        const { deleteFileDniAndValidate } = this.props;
        const dragNDropDniFront = this.buildDragNDrop(
            'dniDocumentFront',
            this.handleOnChangeFileDni,
            deleteFileDniAndValidate
        );
        const dragNDropDniBack = this.buildDragNDrop(
            'dniDocumentBack',
            this.handleOnChangeFileDni,
            deleteFileDniAndValidate
        );

        return (
            <React.Fragment>
                <FormattedText
                    className="upload-documents-open-young__subtitle"
                    value="uploadDocumentsOpenYoung-uploadDocumentsOpenYoung_youngDocumentation"
                />
                <OKTooltip
                    content="uploadDocumentsOpenYoung-uploadDocumentsOpenYoung_youngTooltip"
                    offset={[15, 0]}
                    placement="right"
                />
                <div className="row">
                    <div className="col-md-6">
                        <FormattedText value="uploadDocumentsOpenYoung-uploadDocumentsOpenYoung_dniFront" />
                        <div className="upload-documents-open-young__upload-box">
                            {dragNDropDniFront}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <FormattedText value="uploadDocumentsOpenYoung-uploadDocumentsOpenYoung_dniBack" />
                        <div className="upload-documents-open-young__upload-box">
                            {dragNDropDniBack}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    buildFamilyBookDocumentation() {
        const {
            addNewContainerForFile,
            deleteFileFamilyBookAndValidate,
            immUploadDocumentsOpenYoung
        } = this.props;
        const dragNDropUploadComponents = immUploadDocumentsOpenYoung.getIn(['files', 'familyBook']).map(immFile => {
        const dragNDropFamilyBook = this.buildDragNDrop(
            immFile.get('name'),
            this.handleOnChangeFileFamilyBook,
            deleteFileFamilyBookAndValidate,
            this.handleOnChangeFileFamilyBook
        );

            return (
                <div className="col-md-6" key={immFile.get('name')}>
                    <div className="upload-documents-open-young__upload-box">
                        {dragNDropFamilyBook}
                    </div>
                </div>
            );
        });

        return (
            <React.Fragment>
                <FormattedText
                    className="upload-documents-open-young__subtitle"
                    value="uploadDocumentsOpenYoung-uploadDocumentsOpenYoung_principalDocumentation"
                />
                <OKTooltip
                    content="uploadDocumentsOpenYoung-uploadDocumentsOpenYoung_principalTooltip"
                    offset={[15, 0]}
                    placement="right"
                />
                <FormattedText
                    className="upload-documents-open-young__family-book"
                    value="uploadDocumentsOpenYoung-uploadDocumentsOpenYoung_familyBook"
                />
                <div className="row">
                    {dragNDropUploadComponents}
                </div>
                <OKButton
                    disabled={immUploadDocumentsOpenYoung.get('disableAddNewFile')}
                    leftIcon="icon-agregar"
                    modifier="ghost"
                    onClick={addNewContainerForFile}
                >
                    <FormattedText
                        value="uploadDocumentsOpenYoung-uploadDocumentsOpenYoung_addDocumentButton"
                    />
                </OKButton>
            </React.Fragment>
        );
    }

    render() {
        const { textInfoMessage } = this.props;
        const tipsPicturesSection = this.buildTipsPictures();
        const dniDocumentation = this.buildDniDocumentation();
        const familyBookDocumentation = this.buildFamilyBookDocumentation();
        let contactCenterMessageContent;
        let infoMessage;

        if (!!textInfoMessage && hasTranslation(textInfoMessage)) {
            infoMessage = (
                <OKMessage>
                    <FormattedText value={textInfoMessage} />
                </OKMessage>
            );
        }

        if (__CONTACT_CENTER__) {
            const ccText = isPrintOfficeMode() ? 'uploadDocumentsOpenYoung_checkDniDocumentation' : 'uploadDocumentsOpenYoung_checkSizeFilePicture';
            contactCenterMessageContent = (
                <BlockInfo extraClass="upload-documents-open-young__block-info">
                    <FormattedText value={`uploadDocumentsOpenYoung-${ccText}`} />
                </BlockInfo>
            );
        }

        return (
            <section className="upload-documents-open-young">
                {infoMessage}
                {tipsPicturesSection}
                {contactCenterMessageContent}
                {dniDocumentation}
                {familyBookDocumentation}
            </section>
        );
    }
}

UploadDocumentsOpenYoung.propTypes = {
    addFileDniAndValidate: PropTypes.func.isRequired,
    addFileFamilyBookAndValidate: PropTypes.func.isRequired,
    addNewContainerForFile: PropTypes.func.isRequired,
    deleteFileDniAndValidate: PropTypes.func.isRequired,
    deleteFileFamilyBookAndValidate: PropTypes.func.isRequired,
    immUploadDocumentsOpenYoung: PropTypes.object.isRequired,
    textInfoMessage: PropTypes.string,
};

module.exports.constructor = UploadDocumentsOpenYoung;

module.exports.UploadDocumentsOpenYoung = connect(null,
    {
        addFileDniAndValidate: uploadDocumentsOpenYoungActions.addFileDniAndValidate,
        addFileFamilyBookAndValidate: uploadDocumentsOpenYoungActions.addFileFamilyBookAndValidate,
        addNewContainerForFile: uploadDocumentsOpenYoungActions.addNewContainerForFile,
        deleteFileDniAndValidate: uploadDocumentsOpenYoungActions.deleteFileDniAndValidate,
        deleteFileFamilyBookAndValidate: uploadDocumentsOpenYoungActions.deleteFileFamilyBookAndValidate,
        validate: uploadDocumentsOpenYoungActions.validate,
    }
)(UploadDocumentsOpenYoung);
